import { render, staticRenderFns } from "./CustomizeDocuments.vue?vue&type=template&id=241f1426&"
import script from "./CustomizeDocuments.vue?vue&type=script&lang=js&"
export * from "./CustomizeDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeDocuments.vue?vue&type=style&index=0&id=241f1426&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports